export enum TypographyColor {
  Primary = "primary",
  Secondary = "secondary",
  Error = "error",
  Default = "default",
  Silver = "silver",
  Gray = "gray",
  Graphite = "graphite",
  Charcoal = "charcoal",
  Disable = "disable",
  Success = "success",
  Warning = "warning",
}

export enum TypographyVariant {
  // Heading h1
  /**
    @property font-size: 48px; 
    @property line-height: 67.2px;
    @property font-weight: 700;
    @property font-family: Poppins;
  // */
  HeadingH1Bold = "heading-h1-bold",

  // Heading h2
  /**
    @property font-size: 40px;
    @property line-height: 56px;
    @property font-weight: 700;
    @property font-family: Poppins;
  */
  HeadingH2Bold = "heading-h2-bold",

  // Heading h3
  /**
    @property font-size: 32px;
    @property line-height: 44.8px;
    @property font-weight: 700;
    @property font-family: Poppins;
  */
  HeadingH3Bold = "heading-h3-bold",

  // Heading h4
  /**
    @property font-size: 24px;
    @property line-height: 33.6px;
    @property font-weight: 700;
    @property font-family: Poppins;
  */
  HeadingH4Bold = "heading-h4-bold",

  // Heading h5
  /**
    @property font-size: 20px;
    @property line-height: 28px;
    @property font-weight: 700;
    @property font-family: Poppins;
  */
  HeadingH5Bold = "heading-h5-bold",

  // Heading h6
  /**
    @property font-size: 16px;
    @property line-height: 22.4px;
    @property font-weight: 700;
    @property font-family: Poppins;
  */
  HeadingH6Bold = "heading-h6-bold",

  // Body b1
  /**
    @property font-size: 24px; 
    @property line-height: 33.6px;
    @property font-family: Poppins;
    @property font-weight: 700;
  */
  BodyB1Bold = "body-b1-bold",
  /**
    @property font-size: 24px; 
    @property line-height: 33.6px;
    @property font-family: Poppins;
    @property font-weight: 500;
  */
  BodyB1Medium = "body-b1-medium",
  /**
    @property font-size: 24px; 
    @property line-height: 33.6px;
    @property font-family: Poppins;
    @property font-weight: 400;
  */
  BodyB1Regular = "body-b1-regular",

  // Body b2
  /**
    @property font-size: 20px; 
    @property line-height: 28px;
    @property font-family: Poppins;
    @property font-weight: 700;
  */
  BodyB2Bold = "body-b2-bold",
  /**
    @property font-size: 20px; 
    @property line-height: 28px;
    @property font-family: Poppins;
    @property font-weight: 500;
  */
  BodyB2Medium = "body-b2-medium",
  /**
    @property font-size: 20px; 
    @property line-height: 28px;
    @property font-family: Poppins;
    @property font-weight: 400;
  */
  BodyB2Regular = "body-b2-regular",

  // Body b3
  /**
    @property font-size: 18px; 
    @property line-height: 25.2px;
    @property font-family: Poppins;
    @property font-weight: 700;
  */
  BodyB3Bold = "body-b3-bold",
  /**
    @property font-size: 18px; 
    @property line-height: 25.2px;
    @property font-family: Poppins;
    @property font-weight: 500;
  */
  BodyB3Medium = "body-b3-medium",
  /**
    @property font-size: 18px; 
    @property line-height: 25.2px;
    @property font-family: Poppins;
    @property font-weight: 400;
  */
  BodyB3Regular = "body-b3-regular",

  // Body b4
  /**
    @property font-size: 16px; 
    @property line-height: 22.4px;
    @property font-family: Poppins;
    @property font-weight: 700;
  */
  BodyB4Bold = "body-b4-bold",
  /**
    @property font-size: 16px; 
    @property line-height: 22.4px;
    @property font-family: Poppins;
    @property font-weight: 500;
  */
  BodyB4Medium = "body-b4-medium",
  /**
    @property font-size: 16px; 
    @property line-height: 22.4px;
    @property font-family: Poppins;
    @property font-weight: 400;
  */
  BodyB4Regular = "body-b4-regular",

  // Body b5
  /**
    @property font-size: 14px; 
    @property line-height: 19.6px;
    @property font-family: Poppins;
    @property font-weight: 700;
  */
  BodyB5Bold = "body-b5-bold",
  /**
    @property font-size: 14px; 
    @property line-height: 19.6px;
    @property font-family: Poppins;
    @property font-weight: 500;    
  */
  BodyB5Medium = "body-b5-medium",
  /**
    @property font-size: 14px; 
    @property line-height: 19.6px;
    @property font-family: Poppins;
    @property font-weight: 400;
  */
  BodyB5Regular = "body-b5-regular",

  // Body b6
  /**
    @property font-size: 12px; 
    @property line-height: 16.8px;
    @property font-family: Poppins;
    @property font-weight: 700;
  */
  BodyB6Bold = "body-b6-bold",
  /**
    @property font-size: 12px; 
    @property line-height: 16.8px;
    @property font-family: Poppins;
    @property font-weight: 500;    
  */
  BodyB6Medium = "body-b6-medium",
  /**
    @property font-size: 12px; 
    @property line-height: 16.8px;
    @property font-family: Poppins;
    @property font-weight: 400;
  */
  BodyB6Regular = "body-b6-regular",
}

export const typographyMapping: { [key in TypographyVariant]: string } = {
  // Heading
  "heading-h1-bold": "h1",
  "heading-h2-bold": "h2",
  "heading-h3-bold": "h3",
  "heading-h4-bold": "h4",
  "heading-h5-bold": "h5",
  "heading-h6-bold": "h6",

  // Body b1
  "body-b1-bold": "p",
  "body-b1-medium": "p",
  "body-b1-regular": "p",

  // Body b2
  "body-b2-bold": "p",
  "body-b2-medium": "p",
  "body-b2-regular": "p",

  // Body b3
  "body-b3-bold": "p",
  "body-b3-medium": "p",
  "body-b3-regular": "p",

  // Body b4
  "body-b4-bold": "p",
  "body-b4-medium": "p",
  "body-b4-regular": "p",

  // Body b5
  "body-b5-bold": "p",
  "body-b5-medium": "p",
  "body-b5-regular": "p",

  // Body b6
  "body-b6-bold": "p",
  "body-b6-medium": "p",
  "body-b6-regular": "p",
};
